<Panel mb="nm" overflow="hidden">

  <Label 
    sm bold color="dark" pl="xs"
    w={stacked ? "100%" : "14rem" }>
    {label}
    {#if required}<Text color="orange" md>*</Text>{/if}
  </Label>
  
  {#if stacked}<br>{/if}

  <slot></slot>

  {#if hints}
  <Panel line="fit">
    <Text color="muted" xs>{hints}</Text>
  </Panel>
  {/if}

</Panel>

<script>
  import { Panel, Heading, Text, Label, Input, Textarea, Select } from 'svelte-stylo'

  export let 
    label = '',
    required = false,
    hints = null,
    stacked = false;

</script>
